/**
 * TODO: Remove this file once the Inkive SDK is updated
 *
 * All of the dirty hacks to make the Inkive SDK work in the Fluer Editor
 * It should be only done in this file
 */
import { svgNamespace } from './config/namespaces';
import { inkiveType } from './types';

declare global {
  interface Window {
    INKIVE: inkiveType;
    NAMESPACE_URIS: any;
    CONFIG: any;
  }
}

export function getCanvas(): any {
  return getInkive().Tool.getInstance().editor.canvas;
}

export function getEditor(): any {
  return getInkive().Tool.getInstance().editor;
}

export function getInkive(): inkiveType {
  window.INKIVE = {
    ...window.INKIVE,
    C: {
      ...(window.INKIVE?.C || {}),
      HEADLESS: true,
    },
  };

  return window.INKIVE;
}

export const svgNamespaces = (() => {
  window.NAMESPACE_URIS = window.NAMESPACE_URIS ?? svgNamespace;

  return svgNamespace;
})();

export const config = (() => {
  window.CONFIG = window.CONFIG ?? {};

  return window.CONFIG;
})();
